import React from 'react'
import { ListTagsProps } from './types'

export const ListTags: React.FC<ListTagsProps> = ({ listTags }) => {
	return (
		<div className="flex flex-wrap items-center gap-2 p-2">
			{listTags.map((tag, index) => (
				<p
					key={index}
					className="text-[15px] text-black-1 font-normal font-Inter border border-blue-primary rounded-[32px] px-2 whitespace-nowrap overflow-hidden text-ellipsis"
				>
					{tag}
				</p>
			))}
		</div>
	)
}
